"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_bootstrap_1 = require("react-bootstrap");
const Footer = () => {
    return (react_1.default.createElement(react_bootstrap_1.Navbar, { bg: "light", className: "mt-auto small" },
        react_1.default.createElement(react_bootstrap_1.Container, null,
            react_1.default.createElement(react_bootstrap_1.Row, { className: "align-items-center justify-content-between flex-nowrap gx-2 w-100" },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto" },
                    react_1.default.createElement(react_bootstrap_1.Navbar.Text, { className: "d-inline-flex align-items-center gap-2" },
                        "\u00A9 ",
                        new Date().getFullYear(),
                        " ENVI Konsulting")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: "auto", className: "text-end" },
                    react_1.default.createElement(react_bootstrap_1.Navbar.Text, { className: "d-inline-flex align-items-center gap-2" },
                        react_1.default.createElement("a", { href: "https://www.envi.com.pl", target: "_blank", rel: "noreferrer", style: { textDecoration: "none" } }, "www.envi.com.pl"),
                        react_1.default.createElement("a", { href: "#/privacy", className: "p-1", title: "Prywatno\u015B\u0107 i dane osobowe", "aria-label": "Prywatno\u015B\u0107 i dane osobowe" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faShieldHalved, "aria-hidden": "true" }))))))));
};
exports.default = Footer;
